import React from 'react';
import Typography from '../components/Text/Typography';
import './About.css';

const About: React.FC = () => {
  return (
    <div className="about-page">
      <div className="about-container">
        <Typography variant="h1" className="about-title">
          About Dew
        </Typography>
        
        <div className="about-content">
          <Typography variant="body" className="about-intro">
            Dew is a free skincare routine personalizer designed to make skincare simple, thoughtful, and effective.
          </Typography>

          <Typography variant="body">
            This project began with my own frustrations. My bathroom cabinet was overflowing with expensive, celebrity-endorsed products—yet my acne wouldn't go away. Despite spending hundreds of dollars, I saw little to no improvement. It was discouraging, and honestly, confusing.
          </Typography>

          <Typography variant="body">
            So I started doing my own research. I learned that skincare isn't just about buying the "best" products—it's about understanding your skin and being consistent with the right routine. I discovered that product order matters, that certain ingredients shouldn't be mixed, and that more isn't always better. What I needed wasn't another serum—it was clarity.
          </Typography>

          <Typography variant="body">
            Most importantly, I came to realize that skincare is a journey. It's not something you fix overnight with one miracle cream. It takes time, patience, and small, smart changes along the way. That shift in mindset changed everything for me.
          </Typography>

          <Typography variant="body">
            I created Dew to help others who might be feeling just as overwhelmed. Dew gives you a personalized routine based on your skin's needs, helps you learn what ingredients actually do, and makes it easier to build a consistent habit—without the noise, the hype, or the guesswork.
          </Typography>

          <Typography variant="body">
            If Dew helps you, I'd love to hear about it. And if you think a friend, sibling, or coworker could benefit from a little skincare clarity, please share it with them too. This is just the beginning, and your feedback helps shape where Dew goes next.
          </Typography>

          <div className="about-signature">
            <Typography variant="body" style={{ fontStyle: 'italic' }}>
              With care,
            </Typography>
            <Typography variant="body" className="signature-name">
              Don
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
